declare const emailAddressBrand: unique symbol

export type EmailAddress = string & { readonly [emailAddressBrand]: 'EmailAddress' }

export const toEmailAddress = (rawEmailAddress: string) =>
  rawEmailAddress.trim().toLowerCase() as EmailAddress
